import { Autocomplete, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import SkuDataSet from "../data/UnidadeArmazenamentoDataSet";
import { hasInCache } from "../../helper/cacheHelper";
import UnidadeArmazenamento from "../classes/UnidadeArmazenamento";
import { t } from "i18next";

export default function AutocompleteSKU(props: AutocompleteSKUProps) {
    const dataSet = new SkuDataSet();
    const [data, setData] = useState<UnidadeArmazenamento[]>([]);
    const [dataFilter, setDataFilter] = useState<UnidadeArmazenamento[]>([]);

    useEffect(() => {
        if (hasInCache("UnidadeArmazenamentoCache")) {
            try{
                setData(JSON.parse(String(localStorage.getItem("UnidadeArmazenamentoCache"))));
            }catch(err){
                dataSet.ListarAtivos().then((result) => setData(result));
            }

        } else {
            dataSet.ListarAtivos().then((result) => setData(result));
        }
        /*    if (hasInCache("CodigoFornecedorSAPSelecionado")) {
                var _codigo: string = String(localStorage.getItem("CodigoFornecedorSAPSelecionado"));
                setDataFilter(data.filter(f => f.codigoFornecedorSAP.toString().startsWith(_codigo)));
            }*/
    }, [])


    useEffect(() => {
        if (dataFilter !== null && dataFilter !== undefined && dataFilter.length === 1) {
            localStorage.setItem("UnidadeArmazenamentoSel", String(dataFilter[0].idSKU));
            // console.log(dataFilter[0].idSKU);
        }
        else
            if (dataFilter.length !== 1)
                localStorage.removeItem("UnidadeArmazenamentoSel");
    }, [dataFilter])

    const handlerOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDataFilter(data.filter(f => f.idSKU.toString().startsWith(event.target.value)))
    }

    return (
        <>
            <Autocomplete
                // freeSolo
                {...(props.multiple ? { multiple: true } : { freeSolo: true })}
                id="autocompleteSKU"
                disableClearable
                options={data.map((option: any) => option.idSKU + ' - ' + option.descricao)}
                onChange={(e, newValue) => { 
                    setDataFilter(data.filter(f => (f.idSKU.toString() + ' - ' + f.descricao) === String(e.currentTarget.textContent))); 
                    props.onChangeCallback?.(e,newValue);
                }}
                renderInput={(params) => (<TextField
                    {...params}
                    label={t("common.autoComplete.listaTecnica.label")}
                    InputProps={{
                        ...params.InputProps,
                        type: 'search',
                    }}
                    onChange={handlerOnChange}
                />
                )}
            />
        </>
    )
}

interface AutocompleteSKUProps {
    multiple?: boolean;
    onChangeCallback?: (event: any, newValue: any) => void;
}
